'use client';

import { ComponentProps } from 'react';

import { debounce, useEventListener } from 'codekit';
import { transparentize } from 'polished';

import { useTheme } from 'contexts/ThemeContext';
import { cn } from 'utils/cn';

import styles from './styles.module.css';

interface LuminousAnimationProps {
	selector?: string;
}

export function LuminousAnimationHandler({
	selector = '.card',
}: LuminousAnimationProps) {
	// Event Listeners
	useEventListener('mousemove', (event) => {
		const all = document.querySelectorAll<HTMLElement>(selector);

		debounce(() => {
			Array.from(all).forEach((e) => {
				const blob = e.querySelector<HTMLElement>('.blob');
				const fakeBlob = e.querySelector<HTMLElement>('.fake-blob');

				if (!blob || !fakeBlob) return;

				const rec = fakeBlob.getBoundingClientRect();
				blob.style.opacity = '1';

				// blob.style.transform = `translate(${
				// 	event.clientX - rec.left - rec.width / 2
				// }px,${event.clientY - rec.top - rec.height / 2}px)`;

				blob.animate(
					[
						{
							transform: `translate(${
								event.clientX - rec.left - rec.width / 2
							}px,${event.clientY - rec.top - rec.height / 2}px)`,
						},
					],
					{
						duration: 300,
						fill: 'forwards',
					},
				);
			});
		}, 5)();
	});

	return null;
}

export function LuminousAnimationCard({
	className,
	...props
}: ComponentProps<'div'>) {
	// Hooks
	const theme = useTheme();

	return (
		<div className={cn(styles.card, 'card')} {...props}>
			<div
				className={cn(styles.card__inner, className)}
				style={
					{
						'--luminous-animation-highlight-color': transparentize(
							0.2,
							theme.colors.background,
						),
					} as React.CSSProperties
				}
			>
				{props.children}
			</div>

			<div className={cn('blob', styles.blob)} />
			<div className={cn('fake-blob', styles.fake_blob)} />
		</div>
	);
}
